var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-time-switch"},[_c('div',{staticClass:"data-time-switch-header"},[_vm._v("时间")]),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('ul',{ref:"data-time-switch-list",staticClass:"data-time-switch-list"},_vm._l((_vm.options),function(option){return _c('li',{key:option.value,class:{
        active: option.value === _vm.value
      },on:{"click":function($event){return _vm.onclick(option)}}},[_vm._v(_vm._s(option.label))])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57d37dba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataTimeSwitch/index.vue
// module id = null
// module chunks = 